import { helpers } from "@vuelidate/validators";

export const technicalValidation = helpers.regex(/^\w+$/);

export const cronExpressionValidation = helpers.regex(/(@(annually|yearly|monthly|weekly|daily|hourly|reboot))|(@every (\d+(ns|us|µs|ms|s|m|h))+)|((((\d+,)+\d+|(\d+(\/|-)\d+)|\d+|\*) ?){5,7})/);

// check if number not zero
export const notZeroValidation = helpers.regex(/^[1-9]/);

// check if whitespace in string
export const whitespaceValidation = helpers.regex(/^\S+$/);

// check if the password length ist min 8 and max 32
export const passwordLengthRegex = /^.{8,32}$/;
export const passwordLengthValidation = helpers.regex(passwordLengthRegex);

// Check if at least one upper and lower case letter
export const minOneLowerAndUpperCaseRegex = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
export const minOneLowerAndUpperCaseValidation = helpers.regex(minOneLowerAndUpperCaseRegex);

// Check if at least one number is present
export const atLeastOneNumberRegex = /\d/;
export const atLeastOneNumberValidation = helpers.regex(atLeastOneNumberRegex);

// Check if at least one special character (from the ANSI character set)
export const atLeastOneSpecialCharacterRegex = /[^a-zA-Z0-9]/;
export const atLeastOneSpecialCharacterValidation = helpers.regex(atLeastOneSpecialCharacterRegex);

// check if value is a string with only numbers
// also can be null
export const stringWithNumbersValidation = helpers.regex(/^(?:\d+|null)$/);

// check that the maximum length of 15 characters has not been exceeded
export const maxLengthOfFifteenValidation = helpers.regex(/^.{0,15}$/);

// check whether it is a valid color (any css color format)
export const isColorValidation = helpers.regex(/^(?<rgb>rgb\((?<red>\d{1,3}),\s*\d{1,3},\s*\d{1,3}\))$|^(?<rgba>rgba\(\d{1,3},\s*\d{1,3},\s*\d{1,3},\s*[01](\.\d{1,2})?\))$|^(?<hsla>hsla\(\d{1,3},\s*\d{1,3}%,\s*\d{1,3}%,\s*[01](\.\d{1,2})?\))$|^(?<hsl>hsl\(\d{1,3},\s*\d{1,3}%,\s*\d{1,3}%\))$|^(?<hex>#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})(\d{2})?)$|^(?<cmyk>cmyk\(\d{1,3}%,\s*\d{1,3}%,\s*\d{1,3}%,\s*\d{1,3}%\))$/gm);

// check if icon format is correct
export const isIconFormatCorrect = helpers.regex(/^mdi-/i);

// checks whether a string consists exclusively of certain permitted characters
export const charactersRegex = helpers.regex(/^[a-zA-Z0-9_\-ßäöüÄÖÜ]+$/);
